import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "addOnRef"
}
const _hoisted_2 = { class: "hidden sm:flex gap-5 max-h-[600px] font-light text-gary-text-color text-sm relative pr-[15px]" }
const _hoisted_3 = { class: "basis-1/2 w-[50%]" }
const _hoisted_4 = { class: "w-[50%] basis-1/2 pt-[1.875rem] px-[1rem] mb-[5.625rem] flex-shrink flex-col overflow-y-scroll" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = {
  key: 2,
  class: "inline-block ml-[9px] text-gary-text-color font-bold text-[0.937rem]"
}
const _hoisted_8 = {
  key: 3,
  class: "inline-block ml-[9px] text-gary-text-color font-bold text-[0.937rem]"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "hidden option radio-group flex items-center mt-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "款式", -1)
const _hoisted_12 = { class: "flex-grow ml-8" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "hidden option select flex items-center mt-[1.875rem]" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "材質", -1)
const _hoisted_16 = { class: "flex-grow ml-8" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = {
  key: 0,
  class: "option select flex items-center mt-8"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "數量", -1)
const _hoisted_20 = { class: "flex-grow pl-8" }
const _hoisted_21 = { class: "w-[90px]" }
const _hoisted_22 = { class: "hidden option select flex items-center mt-[1.875rem]" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "字體", -1)
const _hoisted_24 = { class: "flex-grow ml-8" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "hidden option select flex items-center mt-[1.875rem]" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "文字", -1)
const _hoisted_28 = { class: "flex-grow ml-8" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = {
  key: 2,
  class: "include-description"
}
const _hoisted_31 = { class: "flex basis-full" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color text-sm basis-[60px] w-[60px]" }, " 包含 ", -1)
const _hoisted_33 = { class: "flex-grow ml-8 whitespace-pre-line tracking-widest leading-[20px] text-sm mb-1" }
const _hoisted_34 = {
  key: 4,
  class: "option select items-center mt-[1.875rem]"
}
const _hoisted_35 = { class: "flex items-center flex-wrap mb-[20px] pr-[1px]" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color font-light text-sm" }, " 產品說明 ", -1)
const _hoisted_37 = {
  key: 0,
  class: "flex flex-col mb-3 tracking-[.06em]"
}
const _hoisted_38 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_39 = { class: "inline-flex" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "・", -1)
const _hoisted_41 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_42 = {
  key: 5,
  class: "option select items-center my-[1.875rem]"
}
const _hoisted_43 = { class: "flex items-center flex-wrap" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color font-light text-sm" }, " 注意事項 ", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_47 = { class: "inline-flex" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "・", -1)
const _hoisted_49 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_50 = {
  key: 0,
  class: "flex gap-3 absolute bottom-[15px] right-0 w-[50%] px-[2.875rem]"
}
const _hoisted_51 = { class: "basis-1/2" }
const _hoisted_52 = { class: "basis-1/2" }
const _hoisted_53 = { class: "sm:hidden flex flex-col max-h-[100vh] font-light text-gary-text-color text-sm relative" }
const _hoisted_54 = { class: "flex items-center py-2 px-4" }
const _hoisted_55 = { class: "w-full flex justify-between" }
const _hoisted_56 = { class: "inline-block ml-[9px] text-gary-text-color font-bold text-sm" }
const _hoisted_57 = {
  key: 0,
  class: "inline-block ml-[9px] leading-[20px] text-gary-text-color text-xs"
}
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "overflow-y-scroll" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = { class: "basis-1/2 pt-[1.875rem] px-[1.5rem] mb-[5.625rem] flex-shrink flex-col" }
const _hoisted_62 = { class: "hidden option radio-group flex items-center mt-5" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[35px] tracking-widest" }, "款式", -1)
const _hoisted_64 = { class: "flex-grow ml-8" }
const _hoisted_65 = { class: "" }
const _hoisted_66 = { class: "hidden option select flex items-center mt-[1.875rem]" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[35px] tracking-widest" }, "材質", -1)
const _hoisted_68 = { class: "flex-grow ml-8" }
const _hoisted_69 = { class: "" }
const _hoisted_70 = { class: "hidden option select flex items-center mt-[1.875rem]" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[35px] tracking-widest" }, "字體", -1)
const _hoisted_72 = { class: "flex-grow ml-8" }
const _hoisted_73 = { class: "" }
const _hoisted_74 = { class: "hidden option select flex items-center mt-[1.875rem]" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[35px] tracking-widest" }, "文字", -1)
const _hoisted_76 = { class: "flex-grow ml-8" }
const _hoisted_77 = { class: "" }
const _hoisted_78 = {
  key: 0,
  class: "option select flex items-center mt-5"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "數量", -1)
const _hoisted_80 = { class: "flex-grow" }
const _hoisted_81 = { class: "w-[90px] mx-[6px]" }
const _hoisted_82 = {
  key: 2,
  class: "include-description"
}
const _hoisted_83 = { class: "flex basis-full" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color text-sm basis-[35px] w-[60px]" }, " 包含 ", -1)
const _hoisted_85 = { class: "flex-grow ml-8 whitespace-pre-line tracking-widest leading-[20px] text-sm mb-1" }
const _hoisted_86 = { class: "option select items-center mt-[1.875rem]" }
const _hoisted_87 = { class: "flex items-center flex-wrap" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color font-light text-sm" }, " 產品說明 ", -1)
const _hoisted_89 = { class: "flex flex-col mb-3 tracking-[.06em]" }
const _hoisted_90 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_91 = { class: "inline-flex" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", null, "・", -1)
const _hoisted_93 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_94 = { class: "option select items-center my-[1.875rem]" }
const _hoisted_95 = { class: "flex items-center flex-wrap" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color font-light text-sm" }, " 注意事項 ", -1)
const _hoisted_97 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_98 = { class: "inline-flex" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("span", null, "・", -1)
const _hoisted_100 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_101 = {
  key: 0,
  class: "flex gap-3 justify-center py-[7px]"
}
const _hoisted_102 = { class: "" }
const _hoisted_103 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSquareItem = _resolveComponent("SwiperSquareItem")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RectangImageRadioButton = _resolveComponent("RectangImageRadioButton")!
  const _component_TextRadioButton = _resolveComponent("TextRadioButton")!
  const _component_InputWithButton = _resolveComponent("InputWithButton")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Spacer = _resolveComponent("Spacer")!
  const _component_TransitionPlusButton = _resolveComponent("TransitionPlusButton")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    show: _ctx.show,
    class: "add-no-modal"
  }, {
    body: _withCtx(() => [
      (_ctx.dataLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_SwiperSquareItem, {
                  class: "sticky top-[0px]",
                  customClass: 'g-swiper-square-item-add-on',
                  autoPlay: false,
                  selectItem: _ctx.selectAddOn.CmdyImageList,
                  "onUpdate:selectItem": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectAddOn.CmdyImageList) = $event))
                }, null, 8, ["selectItem"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.selectAddOn.CmdyType === 'AddOn')
                      ? (_openBlock(), _createBlock(_component_Icon, {
                          key: 0,
                          iconName: 'add_on'
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.selectAddOn.CmdyType === 'Package')
                      ? (_openBlock(), _createBlock(_component_Icon, {
                          key: 1,
                          iconName: 'package'
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.selectAddOn.CmdyType === 'AddOn')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 加購商品 - " + _toDisplayString(_ctx.selectAddOn.Name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectAddOn.CmdyType === 'Package')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 禮品包裝 - " + _toDisplayString(_ctx.selectAddOn.Name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.page !== 'shoppingCart')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "+ NT. " + _toDisplayString(_ctx.selectAddOn.MinUnitFeeReal), 1))
                      : _createCommentVNode("", true),
                    (_ctx.page =='shoppingCart')
                      ? (_openBlock(), _createBlock(_component_Icon, {
                          key: 1,
                          iconName: "modal-close",
                          class: "absolute top-4 right-4 cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('ok')))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_RectangImageRadioButton, {
                        name: "test",
                        inputValue: 1,
                        modelValue: _ctx.test,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.test) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_RectangImageRadioButton, {
                        name: "test",
                        inputValue: 2,
                        modelValue: _ctx.test,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.test) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_RectangImageRadioButton, {
                        name: "test",
                        inputValue: 3,
                        modelValue: _ctx.test,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.test) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_RectangImageRadioButton, {
                        name: "test",
                        inputValue: 4,
                        modelValue: _ctx.test,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.test) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_TextRadioButton, {
                        name: "test1",
                        inputValue: 1,
                        text: '霧面',
                        modelValue: _ctx.test,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.test) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextRadioButton, {
                        name: "test1",
                        inputValue: 2,
                        modelValue: _ctx.test,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.test) = $event)),
                        text: '亮面'
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextRadioButton, {
                        name: "test1",
                        inputValue: 3,
                        modelValue: _ctx.test,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.test) = $event)),
                        text: '雷射光'
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                ((_ctx.cmdyType !== 'Package' && _ctx.page !== 'shoppingCart'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_InputWithButton, {
                            onSubtractClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.subtractClick())),
                            onAddClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addClick())),
                            modelValue: _ctx.AddOnCmdyItemRef.CmdyQty,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.AddOnCmdyItemRef.CmdyQty) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_Select, {
                        itemList: [
                      { text: 'Noto Serif TC', value: 'Noto Serif TC' },
                      { text: 'Noto Sans TC', value: 'Noto Sans TC' }
                    ],
                        modelValue: _ctx.selectFont,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectFont) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textPropList, (textProp) => {
                        return (_openBlock(), _createBlock(_component_Input, {
                          key: textProp,
                          modelValue: textProp.text,
                          "onUpdate:modelValue": ($event: any) => ((textProp.text) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      }), 128))
                    ])
                  ])
                ]),
                (_ctx.page !== 'shoppingCart')
                  ? (_openBlock(), _createBlock(_component_Divider, {
                      key: 1,
                      class: "my-[1.875rem]"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.page !== 'shoppingCart')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.selectAddOn.CmdyIncludeDesc), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.page !== 'shoppingCart')
                  ? (_openBlock(), _createBlock(_component_Divider, {
                      key: 3,
                      class: "my-[1.875rem]"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.selectAddOn.SpecDesc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_component_Spacer),
                        _createVNode(_component_TransitionPlusButton, {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showDescript = !_ctx.showDescript)),
                          actived: !_ctx.showDescript
                        }, null, 8, ["actived"])
                      ]),
                      (_ctx.showDescript)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectAddOn.SpecDesc || '{}')
                    .ProductDesc.DescList, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "text-sm text-breadcrumb-color",
                                key: index
                              }, _toDisplayString(item.Spec), 1))
                            }), 128)),
                            _createElementVNode("ul", _hoisted_38, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectAddOn.SpecDesc || '{}')
                      .ProductDesc?.SpecList, (item, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _hoisted_40,
                                    _createElementVNode("span", _hoisted_41, _toDisplayString(item.Spec), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectAddOn.SpecDesc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode(_component_Spacer),
                        _createVNode(_component_TransitionPlusButton, {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showDescript2 = !_ctx.showDescript2)),
                          actived: !_ctx.showDescript2
                        }, null, 8, ["actived"])
                      ]),
                      (_ctx.showDescript2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("ul", _hoisted_46, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectAddOn.SpecDesc || '{}')
                      .WarningList?.SpecList, (item, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(item.Warning), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.page!=='shoppingCart')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_Btn, {
                        text: '取消',
                        width: '100%',
                        type: 'light',
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('cancel')))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_Btn, {
                        text: '確認',
                        width: '100%',
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getSelected()))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_Icon, { iconName: "package" }),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.selectAddOn.Name), 1),
                  _createElementVNode("div", null, [
                    (_ctx.page !== 'shoppingCart')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, " + NT. " + _toDisplayString(_ctx.selectAddOn.MinUnitFeeReal), 1))
                      : _createCommentVNode("", true),
                    (_ctx.page !== 'shoppingCart')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, "+ NT. " + _toDisplayString(_ctx.selectAddOn.MinUnitFeeReal), 1))
                      : _createCommentVNode("", true),
                    (_ctx.page =='shoppingCart')
                      ? (_openBlock(), _createBlock(_component_Icon, {
                          key: 2,
                          iconName: "modal-close",
                          class: "absolute top-2 right-2 cursor-pointer",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('ok')))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_SwiperSquareItem, {
                    class: "sticky top-[0px]",
                    customClass: 'g-swiper-square-item-add-on',
                    autoPlay: false,
                    selectItem: _ctx.selectAddOn.CmdyImageList,
                    "onUpdate:selectItem": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectAddOn.CmdyImageList) = $event))
                  }, null, 8, ["selectItem"])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_RectangImageRadioButton, {
                          name: "test",
                          inputValue: 1,
                          modelValue: _ctx.test,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.test) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_RectangImageRadioButton, {
                          name: "test",
                          inputValue: 2,
                          modelValue: _ctx.test,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.test) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_RectangImageRadioButton, {
                          name: "test",
                          inputValue: 3,
                          modelValue: _ctx.test,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.test) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_RectangImageRadioButton, {
                          name: "test",
                          inputValue: 4,
                          modelValue: _ctx.test,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.test) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_TextRadioButton, {
                          name: "test1",
                          inputValue: 1,
                          text: '霧面',
                          modelValue: _ctx.test,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.test) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_TextRadioButton, {
                          name: "test1",
                          inputValue: 2,
                          modelValue: _ctx.test,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.test) = $event)),
                          text: '亮面'
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_TextRadioButton, {
                          name: "test1",
                          inputValue: 3,
                          modelValue: _ctx.test,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.test) = $event)),
                          text: '雷射光'
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_Select, {
                          itemList: [
                        { text: 'Noto Serif TC', value: 'Noto Serif TC' },
                        { text: 'Noto Sans TC', value: 'Noto Sans TC' }
                      ],
                          modelValue: _ctx.selectFont,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.selectFont) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textPropList, (textProp) => {
                          return (_openBlock(), _createBlock(_component_Input, {
                            key: textProp,
                            modelValue: textProp.text,
                            "onUpdate:modelValue": ($event: any) => ((textProp.text) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        }), 128))
                      ])
                    ])
                  ]),
                  ((_ctx.cmdyType !== 'Package' && _ctx.page !== 'shoppingCart'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _hoisted_79,
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _createVNode(_component_InputWithButton, {
                              onSubtractClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.subtractClick())),
                              onAddClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.addClick())),
                              modelValue: _ctx.AddOnCmdyItemRef.CmdyQty,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.AddOnCmdyItemRef.CmdyQty) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.page !== 'shoppingCart')
                    ? (_openBlock(), _createBlock(_component_Divider, {
                        key: 1,
                        class: "my-[1.875rem]"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.page !== 'shoppingCart')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.selectAddOn.CmdyIncludeDesc), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.page !== 'shoppingCart')
                    ? (_openBlock(), _createBlock(_component_Divider, {
                        key: 3,
                        class: "my-[1.875rem]"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _createVNode(_component_Spacer),
                      _createVNode(_component_TransitionPlusButton, {
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showDescript = !_ctx.showDescript)),
                        actived: !_ctx.showDescript
                      }, null, 8, ["actived"])
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectAddOn.SpecDesc || '{}')
                      .ProductDesc.DescList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "text-sm text-breadcrumb-color",
                          key: index
                        }, _toDisplayString(item.Spec), 1))
                      }), 128)),
                      _createElementVNode("ul", _hoisted_90, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectAddOn.SpecDesc || '{}')
                        .ProductDesc?.SpecList, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            _createElementVNode("div", _hoisted_91, [
                              _hoisted_92,
                              _createElementVNode("span", _hoisted_93, _toDisplayString(item.Spec), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _hoisted_96,
                      _createVNode(_component_Spacer),
                      _createVNode(_component_TransitionPlusButton, {
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.showDescript2 = !_ctx.showDescript2)),
                        actived: !_ctx.showDescript2
                      }, null, 8, ["actived"])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("ul", _hoisted_97, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectAddOn.SpecDesc || '{}')
                        .WarningList?.SpecList, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, [
                            _createElementVNode("div", _hoisted_98, [
                              _hoisted_99,
                              _createElementVNode("span", _hoisted_100, _toDisplayString(item.Warning), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.page !== 'shoppingCart')
                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _createVNode(_component_Btn, {
                        text: '取消',
                        width: '110px',
                        height: '36px',
                        type: 'light',
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$emit('cancel')))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createVNode(_component_Btn, {
                        text: '確認',
                        width: '110px',
                        height: '36px',
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.getSelected()))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["show"]))
}